'use strict';

import { module } from '../app';

module.service('Lookups', [
  '$http', 'authService', 'magViewApi',
  function ($http, authService, magViewApi) {
    return {
      getRaces: function () {
        return $http.get(authService.currentMagViewUrl() + magViewApi + '/lookups/races');
      },
      getLanguages: function () {
        return $http.get(authService.currentMagViewUrl() + magViewApi + '/lookups/languages');
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/domains/lookups.js